module.exports = __webpack_public_path__ + "img/部分销毁.6512a5e0.svg";